import bestPossibleMood from "../images/Mood_ Best Possible.png";
import veryGoodMood from "../images/Mood_ Very Good .png";
import veryBadMood from "../images/Mood_ Very Bad.png";
import okayMood from "../images/Mood_ OK.png";
import worstPossibleMood from "../images/Mood_ Worst Possible.png";
import badMood from "../images/Mood_ Bad.png";
import goodMood from "../images/Mood_Good.png";
import okMood from "../images/Mood_ OK.png";
import beenBetter from "../images/Mood_ BeenBetter.png";
import PrettyGood from "../images/Mood_ PrettyGood.png";
import postive from "../images/Positive.png";
import negative from "../images/Negative.png";
import veryNegative from "../images/Very_Negative.png";
import veryPositive from "../images/Very_Positive.png";
import ArrowRight from "../images/Arrowright.png";
import party from "../images/Party.png";
import love from "../images/Love.png";
import EyeBrows from "../images/Eyebrows.png";
import smileyHeart from "../images/handheart.png";
import hug from "../images/Hug.png";
import ArrowLeft from "../images/Arrowleft.png";
import trash from "../images/ph_trash.png";
import netural from "../images/Neutral.png";
import goldStart from "../images/goldStart.png";
import meessage from "../images/message.png";
import edit from "../images/edit.png";
import s1 from "../images/s1.svg";
import s1a from "../images/s1a.svg";
import Pros from "../images/Pros.svg";
import Pros1 from "../images/Pros1.svg";
import proBanner from "../images/proBanner.svg";
import badge from "../images/badge.svg";
import view from "../images/view.png";
import engagement from "../images/engagement.png";
const images = {
  s1,
  badge,
  view,
  engagement,
  proBanner,
  s1a,
  Pros1,
  Pros,
  meessage,
  trash: trash,
  smileyHeart: smileyHeart,
  ArrowLeft: ArrowLeft,
  hug: hug,
  party: party,
  love: love,
  EyeBrows: EyeBrows,
  bestPossibleMood: bestPossibleMood,
  veryGoodMood: veryGoodMood,
  veryBadMood: veryBadMood,
  okayMood: okayMood,
  worstPossibleMood: worstPossibleMood,
  badMood: badMood,
  goodMood: goodMood,
  okMood: okMood,
  beenBetter: beenBetter,
  PrettyGood: PrettyGood,
  veryNegative: veryNegative,
  veryPositive: veryPositive,
  postive: postive,
  neutral: negative,
  ArrowRight: ArrowRight,
  appLogo: require("../images/metafit.png"),
  logo: require("../images/logo-admin.svg").default,
  lock: require("../images/freeze-icon.svg").default,
  dashboard: require("../images/dashboard-icon.svg").default,
  organizations: require("../images/organizations.svg").default,
  tools: require("../images/tools.svg").default,
  user: require("../images/users.svg").default,
  departmentsActive: require("../images/departments-active.svg").default,
  departments: require("../images/departments.svg").default,
  community: require("../images/community.svg").default,
  innerCircle: require("../images/inner-circle.svg").default,
  encouragement: require("../images/encouragement-groups.svg").default,
  directCare: require("../images/direct-care.svg").default,
  managePros: require("../images/pros-iocn.svg").default,
  reports: require("../images/user-reports.svg").default,
  plans: require("../images/plans.svg").default,
  settings: require("../images/setting.svg").default,
  birkbeckClg: require("../images/birkbeck-clg.svg").default,
  horizontalDots: require("../images/horizontal-dots.svg").default,
  back: require("../images/foot-back.svg").default,
  per: require("../images/per.svg").default,
  new: require("../images/new.svg").default,
  paginationDimLeft: require("../images/paginationHilight-left.svg").default,
  paginationDimRight: require("../images/paginationDim-right.svg").default,
  next: require("../images/foot-next.svg").default,
  univerLogo: require("../images/university-logo.svg").default,
  emailIcons: require("../images/email-icon.svg").default,
  lineDev: require("../images/line-dev.svg").default,
  editAcc: require("../images/edit-acc.svg").default,
  freezAcc: require("../images/freeze-icon.svg").default,
  fileImg: require("../images/file-img.svg").default,
  createCricl: require("../images/create-cricle.svg").default,
  add: require("../images/add-icon.svg").default,
  redDot: require("../images/red-dot.svg").default,
  dotesReact: require("../images/dots-reactions.svg").default,
  backButton: require("../images/back-button.svg").default,
  firstIcon: require("../images/male-avatar.svg").default,
  avatarTow: require("../images/maleavatar-two.svg").default,
  avatarThree: require("../images/male-avatar-three.svg").default,
  avatarFour: require("../images/female-avatar-four.svg").default,
  avatarFive: require("../images/female-avatar-five.svg").default,
  backArrow: require("../images/back-arrow.svg").default,
  questions: require("../images/question.svg").default,
  avatarJohn: require("../images/active-male-avatar.svg").default,
  activeFemail: require("../images/active-female-avatar.svg").default,
  secondFemail: require("../images/second-female-avatar.svg").default,
  secondMail: require("../images/second-male-avatar.svg").default,
  addMore: require("../images/add-more.svg").default,
  addMoreWhite: require("../images/add-more-white.svg").default,
  userProf: require("../images/user-prof.svg").default,
  post: require("../images/post-image.png"),
  commentIcon: require("../images/comment-icon.svg").default,
  imozeIcon: require("../images/imoze-icons.svg").default,
  calender: require("../images/calender-icons.svg").default,
  map: require("../images/map-image.png"),
  uploadLogo: require("../images/upload-logo.svg").default,
  maleTable: require("../images/male-table.svg").default,
  fluentInfo: require("../images/fluent-info.svg").default,
  profileSec: require("../images/profile-sec.svg").default,
  goalIcon: require("../images/goals-crusher.svg").default,
  thoughtIcon: require("../images/thought-leader.svg").default,
  welcomeIcon: require("../images/welcome-warrior.svg").default,
  coins: require("../images/coins.svg").default,
  crossSquar: require("../images/cross-square.svg").default,
  sunday: require("../images/sunday.svg").default,
  encoutMonday: require("../images/encouragment-monday.svg").default,
  userProfileScound: require("../images/user-profile.svg").default,
  codiconVerified: require("../images/codicon_verified-filled.svg").default,
  signls: require("../images/signal.svg").default,
  grayCalender: require("../images/gray-calender.svg").default,
  clockIcon: require("../images/clock-icon.svg").default,
  dollar: require("../images/dollar-light.svg").default,
  camera: require("../images/camera.svg").default,
  matleFitLogo: require("../images/mental-fit-logo.svg").default,
  upload: require("../images/upload.svg").default,
  rightIcon: require("../images/right-icon.svg").default,
  leftIcon: require("../images/left-icon.svg").default,
  hartImage: require("../images/hart-image.png"),
  cricleMedita: require("../images/cricle.svg").default,
  gratitude: require("../images/gratitude.png"),
  icSunday: require("../images/ic-encouragment.svg").default,
  editPost: require("../images/edit-post.svg").default,
  addSumthing: require("../images/add-sumthing.svg").default,
  attitudeicon: require("../images/attitude-icon.svg").default,
  notifications: require("../images/notification-icon.svg").default,
  starFill: require("../images/star-fill.svg").default,
  avatarWith: require("../images/avatar-with-bg.svg").default,
  pinkStar: require("../images/pink-star.svg").default,
  johnAvatar: require("../images/john-avatar.svg").default,
  uploadIcon: require("../images/up-icons.svg").default,
  tableProfileIcon: require("../images/table-pro-icon.svg").default,
  singleCross: require("../images/single-cross.svg").default,
  rightClick: require("../images/right-click.svg").default,
  freezeUserIcon: require("../images/freeze-user-icons.svg").default,
  groupIcons: require("../images/group-icons.svg").default,
  settingOption: require("../images/setting-options.svg").default,
  whiteUplodeIcon: require("../images/white-upload-icon.svg").default,
  dividerLine: require("../images/divider-line.svg").default,
  chevron: require("../images/chevron-down.svg").default,
  bottMessage: require("../images/bott-message.svg").default,
  nameIcons: require("../images/user-name-icons.svg").default,
  logMood: require("../images/log-mood.svg").default,
  deleteIcon: require("../images/delete-icon.svg").default,
  bestMood: require("../images/mood-best-possible.svg").default,
  moodEdit: require("../images/mood-edit.svg").default,
  greatMood: require("../images/Mood_Great.svg").default,
  veryBestMood: require("../images/Mood_Very-Good.svg").default,
  goodMood: require("../images/Mood_Good.svg").default,
  prettyMood: require("../images/Mood_Pretty_Good.svg").default,
  okMood: require("../images/Mood_OK.svg").default,
  betterMood: require("../images/Mood_Been-Better.svg").default,
  badMood: require("../images/Mood_Bad.svg").default,
  veryBadMood: require("../images/Mood_Very-Bad.svg").default,
  mostWorstMood: require("../images/Mood-Worst-Possible.svg").default,
  capa: require("../images/capa.svg").default,
  neutral: netural,
  // negative: require('../images/Negative.svg').default,
  negative: negative,
  veryNagative: require("../images/Very-Negative.svg").default,
  veryPositiveMod: require("../images/Very-Positive-mod.svg").default,
  meditation: require("../images/Meditation.svg").default,
  shape: require("../images/shape.svg").default,
  shapeTwo: require("../images/shape-two.svg").default,
  shapeThree: require("../images/shape-three.svg").default,
  shapeFour: require("../images/shape-four.svg").default,
  shapeFive: require("../images/shape-five.svg").default,
  shapeSix: require("../images/shape-six.svg").default,
  music: require("../images/musical.svg").default,
  spotify: require("../images/spotify.svg").default,
  apple: require("../images/apple.svg").default,
  amazon: require("../images/amazon.svg").default,
  videos: require("../images/videos.png"),
  cardImage: require("../images/Card.png"),
  quotesBack: require("../images/quotes-bg.png"),
  quotesdots: require("../images/only-three-dots.svg").default,
  arrowUp: require("../images/green-dow.svg").default,
  logThoughts: require("../images/log-thoughts.svg").default,
  icEncouragment: require("../images/ic-encouragment-g.svg").default,
  playListsn: require("../images/playlists-n.svg").default,
  affirmations: require("../images/affirmations-ko.svg").default,
  journalicon: require("../images/journal-icon.svg").default,
  therapyicon: require("../images/therapy-icon.svg").default,
  activeOrganizations: require("../images/active-organizations.svg").default,
  ellipseTool: require("../images/ellipse-tool.svg").default,
  activeUser: require("../images/active-users.svg").default,
  activeCommunity: require("../images/active-community.svg").default,
  activeInnerCircle: require("../images/active-inner-circle.svg").default,
  activeEncouragement: require("../images/active-encouragement-groups.svg")
    .default,
  activeDirectCare: require("../images/active-direct-care.svg").default,
  activeManagePros: require("../images/active-pros.svg").default,
  activeReports: require("../images/active-user-reports.svg").default,
  activeSettings: require("../images/active-setting.svg").default,
  activeNotifications: require("../images/active-notification.svg").default,
  innerCircleIcons: require("../images/inner-circles.svg").default,
  selfAwareness: require("../images/self-awareness.svg").default,
  therapy: require("../images/therapy-icon-setting.svg").default,
  selfResources: require("../images/self-help-resources.svg").default,
  engageaPro: require("../images/engage-a-pro.svg").default,
  chevronDown: require("../images/enter-chevron-down.svg").default,
  chevronUP: require("../images/chevron-up.svg").default,
  loogMood: require("../images/log-mood-pic.svg").default,
  arrowLeft: require("../images/arrow-left.svg").default,
  mapModal: require("../images/modal-map.png"),
  crossIcon: require("../images/crossIcon.png"),
  goldStart: goldStart,
  edit,
};

export default images;
